import { connect } from 'react-redux';
import _merge from 'lodash.merge';
import EpisodeTemplateComponent from './episode-template.component';


const mapStateToProps = (state, ownProps) => {
    const { "series-path": seriesPath,  configs } = state.Main;
    const { pathname } =  ownProps.location;
    const path = pathname.replace(seriesPath,"");
    const index = configs.findIndex( item => {
    	return item.path === path;
    });
    const config = configs[index];


    const props = _merge({}, ownProps, config, {
        "imageServer": state.WebView.medscape.config.imageServer,
        "linksTarget": state.WebView.isIframe === true ? "_blank" : ""
    })
    return props;
};
const mapDispatchToProps = dispatch => {
    return {

    }
};

const EpisodeTemplate = connect(mapStateToProps, mapDispatchToProps)(EpisodeTemplateComponent);
export default EpisodeTemplate;